import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import { Link } from "react-router-dom";

const HomeBanner = () => {
  const [movies, setMovies] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const timerRef = useRef(null);

  useEffect(() => {
  const fetchMovies = async () => {
    try {
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const res = await fetch(`${baseUrl}/movies?page=0&size=10&sort=title,asc`);
      if (!res.ok) throw new Error("Lỗi lấy danh sách phim");

      const data = await res.json();
      setMovies(data.content || []);
    } catch (err) {
      console.error("Failed to fetch movies", err);
    }
  };

  fetchMovies();
}, []);


  useEffect(() => {
    if (movies.length === 0) return;

    timerRef.current = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setActiveIndex((prev) => (prev + 1) % movies.length);
        setFade(true);
      }, 500);
    }, 8000);

    return () => clearInterval(timerRef.current);
  }, [movies]);

  const handleThumbnailClick = (index) => {
    clearInterval(timerRef.current);
    setFade(false);
    setTimeout(() => {
      setActiveIndex(index);
      setFade(true);

      timerRef.current = setInterval(() => {
        setFade(false);
        setTimeout(() => {
          setActiveIndex((prev) => (prev + 1) % movies.length);
          setFade(true);
        }, 500);
      }, 5000);
    }, 500);
  };

  if (movies.length === 0)
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );

  const activeMovie = movies[activeIndex];

  return (
    <header
      className={`page-header home-header ${fade ? "fade-in" : "fade-out"}`}
      style={{
        backgroundImage: `url(${activeMovie.backgroundUrl})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
      }}
    >
      <div className="container">
        <div className="banner-content">
          <h4 className="sub-title">BaGalaxy</h4>
          <h2 className="title">
            {activeMovie.title} <br />
            <span>{activeMovie.genres.join(", ")}</span>
          </h2>
          <p className="description">{activeMovie.description}</p>
          <Link className="btn" to={`/watch/${activeMovie.id}`}>
            <i className="ri-play-line"></i> Xem phim
          </Link>
        </div>

        <div className="thumbnails">
          {movies.map((movie, index) => (
            <img
              key={movie.id}
              src={movie.backgroundUrl}
              alt={movie.title}
              className={`thumbnail ${index === activeIndex ? "active" : ""}`}
              onClick={() => handleThumbnailClick(index)}
            />
          ))}
        </div>
      </div>
    </header>
  );
};

export default HomeBanner;
